import { render, staticRenderFns } from "./Reference.vue?vue&type=template&id=72c0cc08"
import script from "./Reference.vue?vue&type=script&lang=js"
export * from "./Reference.vue?vue&type=script&lang=js"
import style0 from "./Reference.vue?vue&type=style&index=0&id=72c0cc08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports